import React from "react";
import { Button, Header, Modal } from "semantic-ui-react";
import { Trans } from "react-i18next";

function Prompt({
  type,
  show,
  title,
  content,
  confirmText,
  cancelText,
  onConfirm,
  onCancel
}) {
  const icon =
    type === "delete" ? "trash" : type === "respawn" ? "redo" : "warning";
  const cancelColor = type === "delete" ? "green" : "red";
  const confirmColor = type === "delete" ? "red" : "green";

  const confirm = confirmText || <Trans i18nKey="prompt.actions.confirm" />;
  const cancel = cancelText || <Trans i18nKey="prompt.actions.cancel" />;

  return (
    <Modal open={show} basic size="small">
      {title && <Header icon={icon} content={title} />}
      {content && (
        <Modal.Content>
          <p>{content}</p>
        </Modal.Content>
      )}
      <Modal.Actions>
        <Button basic color={cancelColor} inverted onClick={onCancel}>
          {cancel}
        </Button>
        <Button color={confirmColor} inverted onClick={onConfirm}>
          {confirm}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default React.memo(Prompt);
